import { useDisclosure } from '@chakra-ui/react'
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons'
import _ from 'lodash'
import type { ItList } from 'types/graphql'

import { navigate, routes } from '@redwoodjs/router'

import BrandButton from 'src/components/widgets/buttons/BrandButton'
import DialogModal from 'src/components/widgets/Modals/DialogModal/DialogModal'
import { getBrandColor } from 'src/lib/utils'

import FooterOverlay from '../FooterOverlay/FooterOverlay'
import OverflowMenu from '../OverflowMenu/OverflowMenu'

const CreatorFooter: React.FC<{ itList: ItList }> = ({ itList }) => {
  const brandColor = getBrandColor(itList.creator)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const openItList = () => {
    if (itList.draftId) {
      onOpen()
    } else {
      navigate(routes.editItList({ id: itList.id }))
    }
  }
  return (
    <FooterOverlay>
      <DialogModal
        text="Published changes will show for everyone who already has your ItList. Try not to remove items fans may have paid for."
        title="Edit Live ItList?"
        icon={faPenToSquare}
        submitButtonProps={{
          bg: brandColor,
          color: 'white',
        }}
        buttonLabels={{
          close: 'Cancel',
          submit: 'Continue',
        }}
        onSubmit={() => {
          navigate(routes.editItList({ id: itList.draftId }))
        }}
        isOpen={isOpen}
        onClose={onClose}
      />
      <BrandButton
        brandColor={brandColor}
        borderRadius="full"
        flex={1}
        onClick={openItList}
        data-testid="CreatorFooter-editButton"
      >
        Edit
      </BrandButton>
      <OverflowMenu itList={_.pick(itList, 'id', 'status')} />
    </FooterOverlay>
  )
}

export default CreatorFooter
